// stores/tab.js
import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useMenuStore } from "@/stores/menu";
import { useLayoutStore } from '@/stores/layout';

export const useTabStore = defineStore("tab", () => {
  const tabs = ref([]);
  const activeTabIndex = ref(0);
  const menuStore = useMenuStore();
  const layoutStore = useLayoutStore();
  
  const addTab = (routeInfo) => {
    const existingTabIndex = tabs.value.findIndex(
      (tab) => tab.path === routeInfo.path
    );

    if (existingTabIndex !== -1) {
      activeTabIndex.value = existingTabIndex;
      return;
    }

    // 메뉴 store에서 label 찾기
    const menuItem = menuStore.findMenuItemByPath(routeInfo.path);
  // 레이아웃 모드 유지
    const currentLayout = layoutStore.layoutMode;

    tabs.value.push({
      id: Date.now(),
      title: menuItem?.label || routeInfo.name,
      path: routeInfo.path,
      query: routeInfo.query || {},
      params: routeInfo.params || {},
      layoutMode: routeInfo.layout || layoutStore.layoutMode // 현재 레이아웃 모드 유지
    });
    activeTabIndex.value = tabs.value.length - 1;
    ///layoutStore.setLayoutMode(currentLayout); // 레이아웃 모드 설정
  };

  const removeTab = (index) => {
    if (tabs.value.length <= 1) return;
    tabs.value.splice(index, 1);

    if (activeTabIndex.value >= index) {
      activeTabIndex.value = Math.max(0, activeTabIndex.value - 1);
    }
  };

  return {
    tabs,
    activeTabIndex,
    addTab,
    removeTab,
  };
});
